import styled from 'styled-components';

export const Campaign = styled.div`
  background-color: #f3f3f3;
  padding: 15px;
  text-align: left;
  border: 1px solid #e6e6e6;
  margin-bottom: 30px;
  svg {
    color: #f9be01;
    margin-right: 15px;
    font-size: 25px;
  }
`;

export const Container = styled.div`
  .form-group {
    text-align: left;
    label {
      font-size: 12px;
      text-transform: uppercase;
      margin-bottom: 2px;
    }
  }
  input[type='submit'].btn.btn-block {
    height: 45px;
    font-size: 14px;
    margin-top: 20px;
    background-color: #28a745;
    &:hover {
      background-color: #32da58;
    }
  }
  #card-wrapper {
    text-align: left;
    display: none;
    @media (min-width: 349px) {
      display: block;
    }
    @media (min-width: 1028px) {
      position: absolute;
      display: none;
    }
    left: 101%;
    top: 135px;
    margin-bottom: 20px;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/creditCard/style.js